import { setContext } from '@apollo/client/link/context'
import { jwtDecode } from 'jwt-decode'



export const authLink = setContext(async (req, {headers}) => {
  let token = localStorage.getItem('token')
  let decorded
  try {
    if(token){
      decorded = jwtDecode(token)
    }
  } catch (err) {
    console.error(err)
  }
  if(!decorded || decorded.exp < Date.now() / 1000){
    const res = await fetch('/api/token', {credentials: 'same-origin'}).then(res => res.json())
    if(res){
      localStorage.setItem('token', res.token)
      token = res.token
    } else {
      alert('サーバーとの通信に失敗しました')
    }
  }
  return {
    headers: {
      ...headers,
      authorization: token
    }
  }
})